import { render, staticRenderFns } from "./EducationalRatingUpdate.vue?vue&type=template&id=49b9b408&"
import script from "./EducationalRatingUpdate.vue?vue&type=script&lang=js&"
export * from "./EducationalRatingUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports